<template>
    <template-layout>
        <div class="py-12 px-4">
            <nav class="mb-2 flex justify-between">
                <h1 class="text-2xl text-theme-1">
                ข่าวประกาศ
                </h1>
                <NewsModal :editState="editData" @closeModal="handleCloseModal" @openModal="reloadTable = false"/>
            </nav>
            <div class="grid grid-cols-12 gap-6">
                <div class="col-span-12 md:col-span-4 lg:col-span-3">
                    <NewsFilter />
                </div>
                <div class="col-span-12 md:col-span-8 lg:col-span-9">
                    <FilterSummary :items="filterSummaryStore" />
                    <Datatable @updateNews="getUpdateNews" :filter="filterValue" :reload-table="reloadTable"/>
                </div>
            </div>
        </div>
    </template-layout>
</template>

<script setup>
import { ref, computed, reactive } from "vue";
import NewsModal from "./container/newsFormModal.vue";
import TemplateLayout from "@/layouts/side-menu/Main.vue";
import FilterSummary from "@/components/filter-summary/index.vue";
import NewsFilter from "@/components/filter-search/NewsFilter.vue"
import { useStore } from "vuex";
import Datatable from "./container/Datatable.vue";

const store = useStore();
const filterSummaryStore = computed(
  () => store.getters["newsFilter/getFilterSummaryArray"]
);
const filterValue = computed(() => store.getters["newsFilter/getFilterForApi"]);
const breadcrumbComputed = reactive([{
  name: "ข่าวสาร",
  active: true
}])
const editData = ref(null)
const reloadTable = ref(false);
const getUpdateNews = (evt)=>{
    editData.value = evt
}
const handleCloseModal = (evt) =>{
    editData.value = null
    reloadTable.value = false
    if(evt) reloadTable.value = evt
}

</script>

<style>

</style>